export default __webpack_public_path__ + "static/media/comment-shape.f24ae3cb.svg";